import React, { useEffect, useState } from "react";
 import axios from "axios";
import { Table, Button, Form } from "react-bootstrap";

const NotificationsPage = () => {
  const [notifications, setNotifications] = useState([]);
  const [adminNote, setAdminNote] = useState("");

  useEffect(() => {
    fetchNotifications();
  }, []);

  const fetchNotifications = () => {
    axios.get("https://subk.education.com.ly/back/api/appointments") // fetch all notifications
      .then((res) => setNotifications(res.data))
      .catch((err) => console.error("Error fetching notifications", err));
  };

  const handleUpdateStatus = (appointmentId, status) => {
    axios
      .put(`https://subk.education.com.ly/back/api/appointments/${appointmentId}/status`, { status, admin_note: adminNote })
      .then(() => {
        setNotifications((prev) =>
          prev.map((n) => (n.id === appointmentId ? { ...n, status } : n))
        );
        alert(status === "approved" ? "تم قبول الموعد" : "تم رفض الموعد");
      })
      .catch((err) => console.error(err));
  };
const statusArabic = {
  pending: "انتظار",
  approved: "تم القبول",
  rejected: "تم الرفض  ",
};
  return (
        <div className="container-fluid">
           <div className="row">
          <div className="col-lg-12">
            <div className="card p-4  ">
             <div className="card-body"   dir="rtl"> 
      <h2>كل الإشعارات</h2>
      {notifications.length === 0 ? (
        <p>لا توجد إشعارات</p>
      ) : (
           <div 
      style={{ 
        maxHeight: "500px", // fixed height
        overflowY: "auto"   // enable vertical scrolling
      }}
    >
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>العميل</th>
              <th>التاريخ والوقت</th>
              <th>ملاحظة العميل</th>
              <th>حالة</th>
              <th>ملاحظات الإدارة</th>
              <th>إجراءات</th>
            </tr>
          </thead>
          <tbody>
            {notifications.map((n) => {
  const isPending = n.status === "pending"; // Only allow action if status is pending
  return (
    <tr key={n.id}>
      <td>{n.customer?.FirstName} {n.customer?.LastName}</td>
      <td>{n.AppointmentDate} - {n.appointment_time}</td>
      <td>{n.CustomerNote ?? "لا يوجد"}</td>
        <td>{statusArabic[n.Status] || n.Status}</td>  {/* Show status in Arabic */}      <td>
        {isPending ? (
          <Form.Control
            as="textarea"
            rows={2}
            value={adminNote}
            onChange={(e) => setAdminNote(e.target.value)}
            placeholder="أضف ملاحظاتك هنا"
          />
        ) : (
          <div>{n.AdminNote || "لا يوجد رد"}</div>
        )}
      </td>
      <td>
        {isPending ? (
          <>
            <Button
              variant="success"
              size="sm"
              className="me-2"
              onClick={() => handleUpdateStatus(n.AppointmentID, "approved")}
            >
              قبول
            </Button>
            <Button
              variant="danger"
              size="sm"
              onClick={() => handleUpdateStatus(n.AppointmentID, "rejected")}
            >
              رفض
            </Button>
          </>
        ) : (
          <div>—</div> // Optional placeholder if already responded
        )}
      </td>
    </tr>
  );
})}

          </tbody>
        </Table></div>
      )}
    </div>     
    </div>  </div>
    </div>
    </div>

  );
};

export default NotificationsPage;
